import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { SeFeHeaderModule } from "se-fe-header";
import { SeFePageModule } from "se-fe-page";
import { SeFeTabGroupModule } from "se-fe-tabs";

@Component({
  selector: 'se-public-api-shell',
  templateUrl: './shell.component.html',
  imports: [SeFePageModule, SeFeHeaderModule, SeFeTabGroupModule, RouterOutlet],

})
export class ShellComponent {
  title = 'API Integrations';
}
